import { createFileRoute, useRouter } from "@tanstack/react-router";

import { LegalVersionPage } from "@/features/content/pages";

export const Route = createFileRoute("/_app/growth/legal/$versionId")({
  component: OneVersion,
});

function OneVersion() {
  const { versionId } = Route.useParams();
  const router = useRouter();
  return (
    <LegalVersionPage
      key={versionId}
      versionId={versionId}
      onDeleted={() => void router.navigate({ to: "/growth/legal", replace: true })}
      onNext={(from) => void router.navigate({ to: "/growth/legal/new", search: { from } })}
    />
  );
}
